import React from 'react';
import Link from 'components/Globals/Base/Link';
import SectionTitle from 'components/Globals/SectionTitle';
import ProductHomePageInStream from 'components/Ad/AdSlot/ProductHomePageInStream';
import type { INativo } from 'interfaces/content/articles/Articles';
import HUBPAGE_TEST_IDS from 'constants/testsIds/hubpage';
import * as S from './CategoryChildStyles';

interface ChildCategoryData {
  childData: INativo[];
}

const CategoryChild: React.FC<ChildCategoryData> = ({ childData }: ChildCategoryData) => (
  <S.Wrapper>
    {childData.map((category, index) => {
      const shouldInsertAd = index === 1 && childData.length >= 4;
      if (category.posts.length === 0) {
        return null; // Skip rendering if there are no posts
      }
      return (
        <React.Fragment key={`category-${category.slug}`}>
          <S.CategorySection>
            <S.HeaderContainer>
              <Link
                href={category.link}
                className='more-link'
              >
                <SectionTitle
                  tag='h2'
                  text={category.name}
                  className='category-title'
                  variant='border'
                  titleDataCy={`${HUBPAGE_TEST_IDS.HUBPAGE_CATEGORY_TITLE}-${category.slug}`}
                />
              </Link>
              <S.MoreLink mobileOnly={false}>
                <Link
                  href={category.link}
                  type='tertiaryButton'
                  className='more-link'
                  dataCy={`${HUBPAGE_TEST_IDS.HUBPAGE_CATEGORY_MORE}-${category.slug}`}
                >
                  More in {category.name}
                </Link>
              </S.MoreLink>
            </S.HeaderContainer>
            {Array.isArray(category.posts) && category.posts.length > 0 && (
              <S.CategoryChildWrapper>
                <S.FeatureArticle $isLeft={index % 2 === 1}>{category.posts[0]}</S.FeatureArticle>

                <S.ArticleList $isLeft={index % 2 === 1}>
                  {category.posts.slice(1).map((postJSX, idx) => (
                    <React.Fragment key={`side-${idx}`}>{postJSX}</React.Fragment>
                  ))}
                </S.ArticleList>
              </S.CategoryChildWrapper>
            )}
          </S.CategorySection>
          {shouldInsertAd && <ProductHomePageInStream id={0} />}
        </React.Fragment>
      );
    })}
  </S.Wrapper>
);

export default CategoryChild;
